/**
 * ページネーション・絞り込み後の表示：記事エリア（#blog-list / #search-results）を
 * 画面上部に表示し、ヒーローではなく一覧から見えるようにする
 */
const LIST_IDS = [ 'blog-list', 'search-results' ];
const FRAGMENT_BLOG = '#blog-list';

/** ブログ・カテゴリページのページネーションリンクに #blog-list を付与する（PHP で付かない場合の保険） */
function ensurePaginationFragment() {
  const blogSection = document.querySelector( '.mj-blog-page' );
  if ( ! blogSection ) return;
  const links = blogSection.querySelectorAll( '.mj-pagination-wrap a[href]' );
  links.forEach( function ( a ) {
    const href = a.getAttribute( 'href' );
    if ( ! href || href.indexOf( FRAGMENT_BLOG ) !== -1 ) return;
    const hashIdx = href.indexOf( '#' );
    const base = hashIdx !== -1 ? href.slice( 0, hashIdx ) : href;
    a.setAttribute( 'href', base + FRAGMENT_BLOG );
  } );
}

function scrollToListOnLoad() {
  const hash = window.location.hash ? window.location.hash.slice( 1 ) : '';
  const bodyPaged = document.body.classList.contains( 'paged' );
  const hasBlogList = !!document.getElementById( 'blog-list' );
  const hasSearchResults = !!document.getElementById( 'search-results' );

  let targetId = null;
  if ( hash && LIST_IDS.includes( hash ) ) {
    targetId = hash;
  } else if ( bodyPaged && hasBlogList ) {
    targetId = 'blog-list';
  } else if ( bodyPaged && hasSearchResults ) {
    targetId = 'search-results';
  }

  if ( ! targetId ) return;
  const el = document.getElementById( targetId );
  if ( ! el ) return;
  el.scrollIntoView( { behavior: 'auto', block: 'start' } );
}

function init() {
  ensurePaginationFragment();
  scrollToListOnLoad();
}

if ( document.readyState === 'loading' ) {
  document.addEventListener( 'DOMContentLoaded', init );
} else {
  init();
}
